var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      staticClass: "pivot-settings-modal",
      attrs: {
        visible: _vm.visible,
        title: "Pivot Ayarları - " + _vm.widget.title,
        width: "90%",
        footer: null,
        destroyOnClose: true,
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "settings-container" },
        [
          _c("div", { staticClass: "header-section" }, [
            _c(
              "div",
              { staticClass: "left-actions" },
              [
                _c("a-input-search", {
                  staticStyle: { width: "250px" },
                  attrs: { placeholder: "Ara...", allowClear: "" },
                  on: { search: _vm.handleSearch },
                  model: {
                    value: _vm.searchQuery,
                    callback: function ($$v) {
                      _vm.searchQuery = $$v
                    },
                    expression: "searchQuery",
                  },
                }),
                _vm._v(" "),
                _c(
                  "a-popover",
                  {
                    attrs: {
                      placement: "bottomLeft",
                      trigger: "click",
                      overlayClassName: "table-filter-popover",
                    },
                    model: {
                      value: _vm.filterVisible,
                      callback: function ($$v) {
                        _vm.filterVisible = $$v
                      },
                      expression: "filterVisible",
                    },
                  },
                  [
                    _c(
                      "template",
                      { slot: "content" },
                      [
                        _c("TableFilter", {
                          attrs: { fields: _vm.fields, value: _vm.filters },
                          on: { input: _vm.onFiltersUpdated },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: {
                          classNames:
                            "" +
                            (_vm.filters.length > 0 ? "active-filters" : ""),
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("filter_alt"),
                        ]),
                        _vm._v(
                          "\n                        Filtre\n                        "
                        ),
                        _vm.filters.length > 0
                          ? _c("span", { staticClass: "filter-count" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.filters.length) +
                                  "\n                        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.filters.length
                          ? _c(
                              "i",
                              {
                                staticClass: "material-icons clear-filters",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.clearFilters.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                },
                              },
                              [_vm._v("close")]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("a-divider", { staticStyle: { margin: "12px 0" } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content-section" },
            [
              _c(
                "div",
                { staticClass: "preview-section" },
                [
                  !_vm.previewData
                    ? _c(
                        "div",
                        { staticClass: "loading-state" },
                        [
                          _c("a-spin"),
                          _vm._v(" "),
                          _c("div", [_vm._v("Pivot yükleniyor...")]),
                        ],
                        1
                      )
                    : _vm.previewData.error
                    ? _c("div", { staticClass: "error-state" }, [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("error_outline"),
                        ]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(_vm.previewData.message))]),
                      ])
                    : _c("pivot-table", {
                        attrs: {
                          data: _vm.previewData,
                          config: _vm.previewSettings,
                          metadata: _vm.previewMetadata,
                          "value-fields": _vm.previewSettings.valueFields,
                        },
                      }),
                ],
                1
              ),
              _vm._v(" "),
              _c("a-divider", {
                staticStyle: { height: "100%", margin: "0 12px" },
                attrs: { type: "vertical" },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "settings-section" },
                [
                  _c(
                    "a-form",
                    { attrs: { form: _vm.form, layout: "vertical" } },
                    [
                      _c(
                        "a-collapse",
                        { attrs: { defaultActiveKey: ["1"] } },
                        [
                          _c(
                            "a-collapse-panel",
                            { key: "1", attrs: { header: "Satır Alanları" } },
                            [
                              _c("pivot-field-selector", {
                                attrs: {
                                  title: "Satır Alanları",
                                  fields: _vm.fields,
                                  "allow-multiple": true,
                                },
                                on: { change: _vm.handleConfigChange },
                                model: {
                                  value: _vm.previewSettings.rowFields,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.previewSettings,
                                      "rowFields",
                                      $$v
                                    )
                                  },
                                  expression: "previewSettings.rowFields",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-collapse",
                        { staticStyle: { "margin-top": "12px" } },
                        [
                          _c(
                            "a-collapse-panel",
                            { key: "1", attrs: { header: "Sütun Alanları" } },
                            [
                              _c("pivot-field-selector", {
                                attrs: {
                                  title: "Sütun Alanları",
                                  fields: _vm.fields,
                                  "allow-multiple": true,
                                },
                                on: { change: _vm.handleConfigChange },
                                model: {
                                  value: _vm.previewSettings.columnFields,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.previewSettings,
                                      "columnFields",
                                      $$v
                                    )
                                  },
                                  expression: "previewSettings.columnFields",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.hasDateFields
                        ? _c(
                            "a-collapse",
                            { staticStyle: { "margin-top": "12px" } },
                            [
                              _c(
                                "a-collapse-panel",
                                {
                                  key: "1",
                                  attrs: { header: "Tarih Gruplandırma" },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "date-grouping-section" },
                                    _vm._l(
                                      _vm.selectedDateFields,
                                      function (dateField) {
                                        return _c(
                                          "div",
                                          {
                                            key: "date-group-" + dateField._id,
                                            staticClass: "date-grouping-item",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "field-label" },
                                              [_vm._v(_vm._s(dateField.name))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-select",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  value: _vm.getDateGrouping(
                                                    dateField._id
                                                  ),
                                                  placeholder:
                                                    "Gruplandırma seçin",
                                                },
                                                on: {
                                                  change: function (val) {
                                                    return _vm.setDateGrouping(
                                                      dateField._id,
                                                      val
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-select-option",
                                                  { attrs: { value: "day" } },
                                                  [_vm._v("Günlük")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  { attrs: { value: "week" } },
                                                  [_vm._v("Haftalık")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  { attrs: { value: "month" } },
                                                  [_vm._v("Aylık")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: { value: "quarter" },
                                                  },
                                                  [_vm._v("3 Aylık")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  { attrs: { value: "year" } },
                                                  [_vm._v("Yıllık")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a-collapse",
                        { staticStyle: { "margin-top": "12px" } },
                        [
                          _c(
                            "a-collapse-panel",
                            { key: "1", attrs: { header: "Değer Alanları" } },
                            [
                              _c(
                                "div",
                                { staticClass: "value-fields-container" },
                                [
                                  _vm._l(
                                    _vm.previewSettings.valueFields,
                                    function (valueField, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: "value-" + index,
                                          staticClass: "value-field-item",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "value-field-config",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "field-row" },
                                                [
                                                  _c(
                                                    "a-select",
                                                    {
                                                      staticStyle: {
                                                        flex: "1",
                                                      },
                                                      attrs: {
                                                        value:
                                                          valueField.fieldId,
                                                        placeholder:
                                                          "Alan seçiniz",
                                                      },
                                                      on: {
                                                        change: function (val) {
                                                          return _vm.onValueFieldChange(
                                                            index,
                                                            val
                                                          )
                                                        },
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.numericFields,
                                                      function (field) {
                                                        return _c(
                                                          "a-select-option",
                                                          {
                                                            key: field._id,
                                                            attrs: {
                                                              value: field._id,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                    " +
                                                                _vm._s(
                                                                  field.name
                                                                ) +
                                                                "\n                                                "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a-select",
                                                    {
                                                      staticStyle: {
                                                        width: "150px",
                                                      },
                                                      attrs: {
                                                        value:
                                                          valueField.aggregation,
                                                      },
                                                      on: {
                                                        change: function (val) {
                                                          return _vm.onAggregationChange(
                                                            index,
                                                            val
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "a-select-option",
                                                        {
                                                          attrs: {
                                                            value: "sum",
                                                          },
                                                        },
                                                        [_vm._v("Toplam")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a-select-option",
                                                        {
                                                          attrs: {
                                                            value: "count",
                                                          },
                                                        },
                                                        [_vm._v("Sayı")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a-select-option",
                                                        {
                                                          attrs: {
                                                            value: "average",
                                                          },
                                                        },
                                                        [_vm._v("Ortalama")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a-select-option",
                                                        {
                                                          attrs: {
                                                            value: "median",
                                                          },
                                                        },
                                                        [_vm._v("Medyan")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a-select-option",
                                                        {
                                                          attrs: {
                                                            value: "min",
                                                          },
                                                        },
                                                        [_vm._v("Minimum")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a-select-option",
                                                        {
                                                          attrs: {
                                                            value: "max",
                                                          },
                                                        },
                                                        [_vm._v("Maximum")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a-select-option",
                                                        {
                                                          attrs: {
                                                            value: "variance",
                                                          },
                                                        },
                                                        [_vm._v("Varyans")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a-select-option",
                                                        {
                                                          attrs: {
                                                            value: "stddev",
                                                          },
                                                        },
                                                        [_vm._v("Std. Sapma")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a-select-option",
                                                        {
                                                          attrs: {
                                                            value:
                                                              "countDistinct",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Benzersiz Sayı"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.previewSettings
                                                    .valueFields.length > 1
                                                    ? _c(
                                                        "a-button",
                                                        {
                                                          attrs: {
                                                            type: "link",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.removeValueField(
                                                                index
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "i",
                                                            {
                                                              staticClass:
                                                                "material-icons",
                                                            },
                                                            [_vm._v("delete")]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "label-row" },
                                                [
                                                  _c(
                                                    "a-input",
                                                    {
                                                      attrs: {
                                                        value: valueField.label,
                                                        placeholder:
                                                          "Özel etiket (opsiyonel)",
                                                        size: "small",
                                                      },
                                                      on: {
                                                        change: function (e) {
                                                          return _vm.onValueLabelChange(
                                                            index,
                                                            e.target.value
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "i",
                                                        {
                                                          staticClass:
                                                            "material-icons",
                                                          staticStyle: {
                                                            "font-size": "16px",
                                                          },
                                                          attrs: {
                                                            slot: "prefix",
                                                          },
                                                          slot: "prefix",
                                                        },
                                                        [_vm._v("label")]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "unit-row" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "unit-label",
                                                    },
                                                    [_vm._v("Birim:")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "a-radio-group",
                                                    {
                                                      attrs: {
                                                        value:
                                                          _vm.getValueFieldUnit(
                                                            index
                                                          ),
                                                        "button-style": "solid",
                                                        size: "small",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "a-radio-button",
                                                        {
                                                          attrs: {
                                                            value: "none",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleValueUnitChange(
                                                                index,
                                                                "none"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("Yok")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a-radio-button",
                                                        {
                                                          attrs: { value: "₺" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleValueUnitChange(
                                                                index,
                                                                "₺"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("₺")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a-radio-button",
                                                        {
                                                          attrs: { value: "$" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleValueUnitChange(
                                                                index,
                                                                "$"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("$")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a-radio-button",
                                                        {
                                                          attrs: { value: "€" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleValueUnitChange(
                                                                index,
                                                                "€"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("€")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a-radio-button",
                                                        {
                                                          attrs: { value: "%" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleValueUnitChange(
                                                                index,
                                                                "%"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("%")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a-radio-button",
                                                        {
                                                          attrs: {
                                                            value: "custom",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.handleValueUnitChange(
                                                                index,
                                                                "custom"
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [_vm._v("Özel")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.getValueFieldUnit(index) ===
                                              "custom"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "unit-config-row",
                                                    },
                                                    [
                                                      _c("a-input", {
                                                        attrs: {
                                                          value:
                                                            valueField.unit &&
                                                            valueField.unit
                                                              .customValue,
                                                          placeholder:
                                                            "Özel birim",
                                                          size: "small",
                                                        },
                                                        on: {
                                                          change: function (e) {
                                                            return _vm.onValueCustomUnitChange(
                                                              index,
                                                              e.target.value
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.getValueFieldUnit(index) !==
                                              "none"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "unit-position-row",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "unit-label",
                                                        },
                                                        [_vm._v("Pozisyon:")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "a-radio-group",
                                                        {
                                                          attrs: {
                                                            value:
                                                              _vm.getValueFieldUnitPosition(
                                                                index
                                                              ),
                                                            "button-style":
                                                              "solid",
                                                            size: "small",
                                                          },
                                                          on: {
                                                            change: function (
                                                              e
                                                            ) {
                                                              return _vm.onValueUnitPositionChange(
                                                                index,
                                                                e.target.value
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "a-radio-button",
                                                            {
                                                              attrs: {
                                                                value: "left",
                                                              },
                                                            },
                                                            [_vm._v("Solda")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "a-radio-button",
                                                            {
                                                              attrs: {
                                                                value: "right",
                                                              },
                                                            },
                                                            [_vm._v("Sağda")]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-top": "12px" },
                                      attrs: { type: "dashed", block: "" },
                                      on: { click: _vm.addValueField },
                                    },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("add")]
                                      ),
                                      _vm._v(
                                        "\n                                    Değer Alanı Ekle\n                                "
                                      ),
                                    ]
                                  ),
                                ],
                                2
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-collapse",
                        { staticStyle: { "margin-top": "12px" } },
                        [
                          _c(
                            "a-collapse-panel",
                            {
                              key: "1",
                              attrs: { header: "Renklendirme Ayarları" },
                            },
                            [
                              _c("pivot-color-settings-panel", {
                                on: { change: _vm.handleConfigChange },
                                model: {
                                  value: _vm.previewSettings.colorSettings,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.previewSettings,
                                      "colorSettings",
                                      $$v
                                    )
                                  },
                                  expression: "previewSettings.colorSettings",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-collapse",
                        { staticStyle: { "margin-top": "12px" } },
                        [
                          _c(
                            "a-collapse-panel",
                            { key: "1", attrs: { header: "Görünüm Ayarları" } },
                            [
                              _c(
                                "a-form-item",
                                [
                                  _c(
                                    "a-checkbox",
                                    {
                                      attrs: {
                                        checked:
                                          _vm.previewSettings.displayOptions
                                            .showTotals,
                                      },
                                      on: {
                                        change: function (e) {
                                          return _vm.onDisplayOptionChange(
                                            "showTotals",
                                            e.target.checked
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    Genel Toplamları Göster\n                                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a-form-item",
                                [
                                  _c(
                                    "a-checkbox",
                                    {
                                      attrs: {
                                        checked:
                                          _vm.previewSettings.displayOptions
                                            .showSubtotals,
                                      },
                                      on: {
                                        change: function (e) {
                                          return _vm.onDisplayOptionChange(
                                            "showSubtotals",
                                            e.target.checked
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    Alt Toplamları Göster\n                                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a-form-item",
                                { attrs: { label: "Ondalık Basamak" } },
                                [
                                  _c("a-input-number", {
                                    staticStyle: { width: "100px" },
                                    attrs: {
                                      value:
                                        _vm.previewSettings.displayOptions
                                          .decimalFormat,
                                      min: 0,
                                      max: 10,
                                    },
                                    on: {
                                      change: function (val) {
                                        return _vm.onDisplayOptionChange(
                                          "decimalFormat",
                                          val
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a-form-item",
                                { attrs: { label: "Boş Hücre Gösterimi" } },
                                [
                                  _c("a-input", {
                                    staticStyle: { width: "100px" },
                                    attrs: {
                                      value:
                                        _vm.previewSettings.displayOptions
                                          .emptyCell,
                                    },
                                    on: {
                                      change: function (e) {
                                        return _vm.onDisplayOptionChange(
                                          "emptyCell",
                                          e.target.value
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a-form-item",
                                [
                                  _c(
                                    "a-checkbox",
                                    {
                                      attrs: {
                                        checked:
                                          _vm.previewSettings.displayOptions
                                            .compactMode,
                                      },
                                      on: {
                                        change: function (e) {
                                          return _vm.onDisplayOptionChange(
                                            "compactMode",
                                            e.target.checked
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    Kompakt Mod\n                                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-actions" },
            [
              _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v("İptal")]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: { type: "primary", loading: _vm.saving },
                  on: { click: _vm.handleSave },
                },
                [_vm._v(" Kaydet ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }